export default "__VITE_ASSET__C$kbhHLU__"